import { gql } from '@apollo/client';

export const fetchEntitlementsByBillingDate = gql`
  query fetchEntitlementsByBillingDate(
    $id: ID!
    $entitlementId: String
    $isTermed: Boolean
    $isBillingCycleChange: Boolean
    $filterOptions: [FilterOption]
  ) {
    entitlementsGroupByBillingDate(
      id: $id
      entitlementId: $entitlementId
      isTermed: $isTermed
      isBillingCycleChange: $isBillingCycleChange
      filterOptions: $filterOptions
    ) {
      id
      billingDateGroup {
        billingDate
        entitlements {
          entitlementNumber
          edition
          billingFrequency
          cloudSiteHostname
          productName
          productId
          latestPeriodEndDate
          endTimestamp
        }
      }
    }
  }
`;
